$(function() {
$('#requestbtn').hide();  
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // 追加されたノードの中に #globo-formbuilder-97431 があるか？
      mutation.addedNodes.forEach((node) => {
        if (
          node.id === 'globo-formbuilder-97431' &&
          node.parentElement === document.body
        ) {
          // ここに処理を書く（例：初期化や表示操作など）
           $("#requestbtn").css('display','flex'); 
          // yourCustomFunction();

          // 一度検出したら監視を止めたい場合
          // observer.disconnect();
        }
      });
    }
  }
});

observer.observe(document.body, {
  childList: true,
});
  
  $(document).on('click', '#requestbtn', function(){
      $('body').addClass("is-fixed");  
      $('.globo-form-app').addClass("active");
      $('.globo-form-app .variant__table-item').removeClass("variant__table-item-soldout");
      $('.globo-form-app .variant__table-item input').prop('disabled', false);	
      $('.globo-form-app .item__quantity').removeAttr('max');
      $('.globo-form-app .variant-item__table-quantity input').prop('disabled', true);
      $('.globo-form-app .variant-item__table-quantity input').val('0');
    
      var ml = $('#ml').text();
      　$("#97431-email").attr("value",ml);
          
          $('.globo-form-app').on("scroll", function(){
             if($('.flatpickr-calendar').hasClass('open')){
               $('.flatpickr-calendar').removeClass('open');
               $("#97431-datetime-1").removeClass('active');
               $(".wizard__submit").focus();
               
             }
         
          });

  });
  $(document).on('click', '.globo-form-id-97431 .globo-form-app .header', function(){
    $('body').removeClass("is-fixed");  
    });
  $(document).on('click', '.globo-formbuilder .overlay', function(){
    $('body').removeClass("is-fixed");  
    });

  
  $(document).on('click', '.table-product__body-item .checkbox-input', function(){
      if ($(this).prop('checked')) {
        $(this).parents(".table-product__body-item").next(".variant__table").find(".variant-item__table-quantity input").prop('disabled', false);
      }
    else{
      $(this).parents(".table-product__body-item").next(".variant__table").find(".variant-item__table-quantity input").prop('disabled', true);
    }
    

  });

  
  $(document).on('click', '.checkbox-wrapper .checkbox-input', function(){
      if ($(this).prop('checked')) {
        $(this).parent().next(".variant-item__table-quantity").find("input").prop('disabled', false);
      }
    else{
      $(this).parent().next(".variant-item__table-quantity").find("input").prop('disabled', true);
    }
    

  });
  
  $(document).on('click', '.gfb__footer .submit', function(){
	if(window.confirm('送信してよろしいですか？')){ // 確認ダイアログを表示

		return true; // 「OK」時は送信を実行

	}
	else{ // 「キャンセル」時の処理

		window.alert('キャンセルされました'); // 警告ダイアログを表示
		return false; // 送信を中止

	}
    

  });


    	

	var number,total_numner;
	var max = 99; //合計最大数
	var $input = $('.quantity-selector .quantity-selector__input'); //カウントする箇所
	var $plus = $('.quantity-selector .quantity-selector__button-plus'); //アップボタン
	var $minus = $('.quantity-selector .quantity-selector__button-minus'); //ダウンボタン
	//合計カウント用関数
	function total() {
		total_numner = 0;
		$input.each(function(val) {
			val = Number($(this).val());
			total_numner += val;
		});
		return total_numner;
	}
	//ロード時
	$(window).on('load', function() {
		$input.each(function() {
			number = Number($(this).val());
            max = Number($(this).parent('.quantity-selector').data("max"));
			if (number == max) {
				$(this).next($plus).prop("disabled", true);
			} else if (number == 0) {
				$(this).prev($minus).prop("disabled", true);
			}
		});
    /*
		total();
		if (total_numner == max) {
			$plus.prop("disabled", true);
		} else {
			$plus.prop("disabled", false);
		}
    */
	});
	//ダウンボタンクリック時
	$minus.on('click', function() {
		/*total();*/
		number = Number($(this).next($input).val());
        max = Number($(this).parent('.quantity-selector').data("max"));
        if(max < 0){
          max = 999;
        }
      
		if (number > 0) {
			$(this).next($input).val(number - 1);
			if ((number - 1) == 0) {
			$(this).prop("disabled", true);
			}
			$(this).next().next($plus).prop("disabled", false);
		} else {
			$(this).prop("disabled", true);
		}
    /*
		total();
    console.log(total_numner);
		if (total_numner < max) {
			$plus.prop("disabled", false);
		}
    */
	});
	//アップボタンクリック時
	$plus.on('click', function() {
		number = Number($(this).prev($input).val());
        max = Number($(this).parent('.quantity-selector').data("max"));
        if(max < 0){
          max = 999;
        }
		if (number < max) {
			$(this).prev($input).val(number + 1);
			if ((number + 1) == max) {
			$(this).prop("disabled", true);
			}
			$(this).prev().prev($minus).prop("disabled", false);
		} else {
			$(this).prop("disabled", true);
		}
    /*
		total();
    console.log(total_numner);
		if (total_numner == max) {
			$plus.prop("disabled", true);
		} else {
			$plus.prop("disabled", false);
		}
    */
	});

    $('[name="quantity"]').on('input change blur', function() {
      var $input = $(this);
      var max = parseInt($input.parents('.product-variants-lists--item').find('.quantity-selector').data('max'), 10);
      var val = parseInt($input.val(), 10);

      if ( max < 0 ) return;
      if (isNaN(val)) return;
  
      if (val > max) {
        $input.val(max);
        alert("申し訳ございません。ご指定の数量は在庫数を超えております。\n在庫数以上のご注文をご希望の場合は、「注文リクエスト」をお送りください。\n（対象商品のみ）");
        return;
      }
      
    });

})

